module.exports = __webpack_public_path__ + "img/Suitcase_Arrow.3e9aa20b.png";